import { useLazyQuery } from '@apollo/client'
import gql from 'graphql-tag'
import { useCallback } from 'react'

export type Order = {
	order_id: string | number,
}

export type OrderPayload = {
	orders: {
		orders: Order[],
	},
}

export const ordersQuery = gql`
	query OrderQuery($orderId: String, $branchId: String) {
		orders(orderId: $orderId, branchId: $branchId)
			@rest(
				type: "OrderPayload"
				path: "/orders-service/orders/search?order_id={args.orderId}&market_id={args.branchId}"
				endpoint: "esapi"
			) {
			orders {
				order_id
			}
		}
	}
`

export type UseOrdersQueryResult = {
	searchOrders: ( orderId: string, branchId?: string ) => void,
	orders: Order[],
	loading: boolean,
	error: any,
}

export default function useOrdersQuery(): UseOrdersQueryResult {
	const [ executeQuery, { data, loading, error } ] = useLazyQuery<OrderPayload>( ordersQuery, {
		errorPolicy: 'all',
		fetchPolicy: 'cache-and-network',
	} )

	const searchOrders = useCallback( ( orderId: string, branchId?: string ) => {
		if ( !orderId ) {
			return
		}

		executeQuery( {
			variables: {
				orderId,
				branchId: branchId ?? '',
			},
		} )
	}, [ executeQuery ] )

	return {
		searchOrders,
		orders: data?.orders?.orders ?? [],
		loading,
		error,
	}
}
